// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../index'
import { alphaSort } from '../../../common/utils'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import StationRow from './StationRow'
import type { Station } from '../../station/stationTypes'
import css from './stationTable.css'
type StationTableProps = {
  data: Array<Station>
}

const StationTable = ({ data }: StationTableProps) => (
  <div className={css.component}>
    <Table>
      <TableBody>
        {data.length ? (
          alphaSort('name', data).map((station, i) => <StationRow data={station} key={i} />)
        ) : (
          <p className={css.empty}>{i18n.t('admin.ingredients.noIngredients')}</p>
        )}
      </TableBody>
    </Table>
  </div>
)

export default StationTable
